<script setup lang="ts">
import img401 from '@/assets/images/401.svg';
import { i18n } from '@/lang';

const t = i18n.global.t;
</script>

<template>
  <div
    data-testid="error-401"
    class="mx-auto flex w-200 max-w-full flex-col items-center text-center"
  >
    <img :src="img401" alt="" class="mb-4 aspect-square h-40" />
    <div class="text-fg my-4 text-lg font-semibold">{{ t('errPage.401.title') }}</div>
    <div class="text-fg-2 text-[15px] leading-5">{{ t('errPage.401.info') }}</div>
  </div>
</template>
